jQuery(document).ready(function ($) {
  // Get the user's IP address
  $.get("https://api.ipify.org?format=json", function (response) {
    var userIP = response.ip;
    console.log("User IP address:", userIP);

    // Get the user's country code based on their IP address
    $.get("https://ipapi.co/" + userIP + "/country_code/", function (countryCode) {
      console.log("User Country Code:", countryCode);

      // Get the referrer URL
      var referrer = document.referrer;
      console.log("Referrer:", referrer);

      // Conditional redirects based on referrer and country code
      if (referrer === "" && countryCode === "PK") {
        console.log("Referrer is empty");
        console.log("Country is " + countryCode);
        // window.location.href = "https://bokitta.pk";
      } else if (referrer === "" && countryCode === "IN") {
        console.log("Referrer is empty");
        console.log("Country is " + countryCode);
        window.location.href = "https://bokitta.in";
      } else if (referrer === "" && countryCode === "GB") {
        console.log("Referrer is empty");
        console.log("Country is " + countryCode);
        window.location.href = "https://bokitta.co.uk";
      }
    });
  });
});
